import React, { Component } from "react";
import { connect } from "react-redux";
import { AddressVerificationComponent } from "../components";
import { updateRequestState, getRequestState, executeDialogAction } from "../../../shared/actions";
import { getContent } from "../../../utils/helper";
import { isEmpty, isEqual } from "lodash";
import {
   addressVerificationSteps,
   advDenialOptions,
   availableAtAdressForVerificationOptions,
   nonAvailabilityAtAdressForVerificationOptions,
} from "../constants";
import {
   candidateVerificationAvailability,
   candidateVerificationNotAvailableReason,
   candidateVerificationNotInterestedReason,
} from "../../../utils/constant";
import { dialogActions } from "../../../shared/DialogsManagement/constants";

class AddressVerification extends Component {
   constructor(props) {
      super(props);

      this.state = {
         step: addressVerificationSteps.AVAILABILITY_AT_ADDRESS,
         selectedVerificationOption: "",
         phoneNumber: "",
         addressVerificationOptions: {
            [addressVerificationSteps.AVAILABILITY_AT_ADDRESS]: {
               [availableAtAdressForVerificationOptions.AVAILABLE]: getContent(
                  props.languageJSON,
                  availableAtAdressForVerificationOptions.AVAILABLE
               ),
               [availableAtAdressForVerificationOptions.NOT_AVAILABLE]: getContent(
                  props.languageJSON,
                  availableAtAdressForVerificationOptions.NOT_AVAILABLE
               ),
               [availableAtAdressForVerificationOptions.DISCARD_VERIFICATION]: getContent(
                  props.languageJSON,
                  availableAtAdressForVerificationOptions.DISCARD_VERIFICATION
               ),
            },
            [addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS]: {
               [nonAvailabilityAtAdressForVerificationOptions.DOCUMENT_NEEDED]: getContent(
                  props.languageJSON,
                  nonAvailabilityAtAdressForVerificationOptions.DOCUMENT_NEEDED
               ),
               [nonAvailabilityAtAdressForVerificationOptions.NOBODY_RESIDES]: getContent(
                  props.languageJSON,
                  nonAvailabilityAtAdressForVerificationOptions.NOBODY_RESIDES
               ),
               [nonAvailabilityAtAdressForVerificationOptions.SHIFTED]: getContent(
                  props.languageJSON,
                  nonAvailabilityAtAdressForVerificationOptions.SHIFTED
               ),
            },
            [addressVerificationSteps.VERIFICATION_DENIAL]: {
               [advDenialOptions.NOT_AWARE]: getContent(props.languageJSON, advDenialOptions.NOT_AWARE),
               [advDenialOptions.NOT_DECIDED]: getContent(props.languageJSON, advDenialOptions.NOT_DECIDED),
               [advDenialOptions.LEFT_JOB]: getContent(props.languageJSON, advDenialOptions.LEFT_JOB),
            },
         },
      };
   }

   componentDidMount = () => {
      const { getRequestState } = this.props;
      getRequestState();
   };

   componentDidUpdate = (prevProps) => {
      const { languageJSON, dialogAction } = this.props;
      if (!isEqual(prevProps.languageJSON, languageJSON) && !isEmpty(languageJSON)) {
         const addressVerificationOptions = {
            [addressVerificationSteps.AVAILABILITY_AT_ADDRESS]: {
               [availableAtAdressForVerificationOptions.AVAILABLE]: getContent(
                  languageJSON,
                  availableAtAdressForVerificationOptions.AVAILABLE
               ),
               [availableAtAdressForVerificationOptions.NOT_AVAILABLE]: getContent(
                  languageJSON,
                  availableAtAdressForVerificationOptions.NOT_AVAILABLE
               ),
               [availableAtAdressForVerificationOptions.DISCARD_VERIFICATION]: getContent(
                  languageJSON,
                  availableAtAdressForVerificationOptions.DISCARD_VERIFICATION
               ),
            },
            [addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS]: {
               [nonAvailabilityAtAdressForVerificationOptions.DOCUMENT_NEEDED]: getContent(
                  languageJSON,
                  nonAvailabilityAtAdressForVerificationOptions.DOCUMENT_NEEDED
               ),
               [nonAvailabilityAtAdressForVerificationOptions.NOBODY_RESIDES]: getContent(
                  languageJSON,
                  nonAvailabilityAtAdressForVerificationOptions.NOBODY_RESIDES
               ),
               [nonAvailabilityAtAdressForVerificationOptions.SHIFTED]: getContent(
                  languageJSON,
                  nonAvailabilityAtAdressForVerificationOptions.SHIFTED
               ),
            },
            [addressVerificationSteps.VERIFICATION_DENIAL]: {
               [advDenialOptions.NOT_AWARE]: getContent(languageJSON, advDenialOptions.NOT_AWARE),
               [advDenialOptions.NOT_DECIDED]: getContent(languageJSON, advDenialOptions.NOT_DECIDED),
               [advDenialOptions.LEFT_JOB]: getContent(languageJSON, advDenialOptions.LEFT_JOB),
            },
         };
         this.setState({
            addressVerificationOptions,
         });
      }
      if (!isEqual(prevProps.dialogAction, dialogAction)) {
         if ((dialogAction || {}).action === dialogActions.COMMON_ACTIONS.CONFIRM_DIALOG) {
            this.goNext();
         }
      }
   };

   handleChange = (key, value) => {
      this.setState({ [key]: value });
   };

   goToScreen = (key, params) => {
      const { history } = this.props;
      history.push({
         pathname: key,
         params: params,
      });
   };

   goBack = () => {
      const { history } = this.props;
      const { step } = this.state;
      if (step === addressVerificationSteps.AVAILABILITY_AT_ADDRESS) {
         history.replace("instructions");
      } else if (step === addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS) {
         this.setState({ step: addressVerificationSteps.AVAILABILITY_AT_ADDRESS });
      } else if (step === addressVerificationSteps.VERIFICATION_DENIAL) {
         this.setState({ step: addressVerificationSteps.AVAILABILITY_AT_ADDRESS });
      }
   };

   goNext = () => {
      const { addressVerificationOptions, selectedVerificationOption, step } = this.state;
      const { updateRequestState } = this.props;
      if (step === addressVerificationSteps.AVAILABILITY_AT_ADDRESS) {
         if (
            selectedVerificationOption ===
            addressVerificationOptions[step][availableAtAdressForVerificationOptions.AVAILABLE]
         ) {
            updateRequestState({
               state: "candidate_availability_captured",
               data: {
                  availability: candidateVerificationAvailability.AVAILABLE,
               },
               nextRoute: "documents",
            });
         } else if (
            selectedVerificationOption ===
            addressVerificationOptions[step][availableAtAdressForVerificationOptions.NOT_AVAILABLE]
         ) {
            this.setState({ step: addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS });
         } else if (
            selectedVerificationOption ===
            addressVerificationOptions[step][availableAtAdressForVerificationOptions.DISCARD_VERIFICATION]
         ) {
            this.setState({ step: addressVerificationSteps.VERIFICATION_DENIAL });
         }
      } else if (step === addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS) {
         if (
            selectedVerificationOption ===
            addressVerificationOptions[step][nonAvailabilityAtAdressForVerificationOptions.DOCUMENT_NEEDED]
         ) {
            this.goToScreen("documents", { needToForward: true });
         } else if (
            selectedVerificationOption ===
            addressVerificationOptions[step][nonAvailabilityAtAdressForVerificationOptions.NOBODY_RESIDES]
         ) {
            updateRequestState({
               state: "candidate_availability_captured",
               data: {
                  availability: candidateVerificationAvailability.NOT_AVAILABLE,
                  not_available_reason: candidateVerificationNotAvailableReason.NOBODY_RESIDES,
               },
               nextRoute: "thankyou",
            });
         } else if (
            selectedVerificationOption ===
            addressVerificationOptions[step][nonAvailabilityAtAdressForVerificationOptions.SHIFTED]
         ) {
            updateRequestState({
               state: "candidate_availability_captured",
               data: {
                  availability: candidateVerificationAvailability.NOT_AVAILABLE,
                  not_available_reason: candidateVerificationNotAvailableReason.SHIFTED,
               },
               nextRoute: "thankyou",
            });
         }
      } else if (step === addressVerificationSteps.VERIFICATION_DENIAL) {
         if (selectedVerificationOption === addressVerificationOptions[step][advDenialOptions.NOT_AWARE]) {
            updateRequestState({
               state: "candidate_availability_captured",
               data: {
                  availability: candidateVerificationAvailability.NOT_INTERESTED,
                  not_interested_reason: candidateVerificationNotInterestedReason.NOT_AWARE,
               },
               nextRoute: "thankyou",
            });
         } else if (selectedVerificationOption === addressVerificationOptions[step][advDenialOptions.NOT_DECIDED]) {
            updateRequestState({
               state: "candidate_availability_captured",
               data: {
                  availability: candidateVerificationAvailability.NOT_INTERESTED,
                  not_interested_reason: candidateVerificationNotInterestedReason.ASSOCIATION_UNCERTAIN,
               },
               nextRoute: "thankyou",
            });
         } else if (selectedVerificationOption === addressVerificationOptions[step][advDenialOptions.LEFT_JOB]) {
            updateRequestState({
               state: "candidate_availability_captured",
               data: {
                  availability: candidateVerificationAvailability.NOT_INTERESTED,
                  not_interested_reason: candidateVerificationNotInterestedReason.LEFT_JOB,
               },
               nextRoute: "thankyou",
            });
         }
      }
   };

   handleConfirmation = () => {
      const { executeDialogAction } = this.props;
      executeDialogAction({
         action: dialogActions.COMMON_ACTIONS.CONFIRMATION_DIALOG,
         data: { content: "Are you sure you want to move ahead with this option? This might impact your address verification" },
      });
   };

   render() {
      const { language, languageJSON, requestState, handleConfirmation } = this.props;
      const { step, selectedVerificationOption, addressVerificationOptions } = this.state;
      return (
         <AddressVerificationComponent
            addressVerificationOptions={addressVerificationOptions}
            step={step}
            goBack={this.goBack}
            goToScreen={this.goToScreen}
            language={language}
            languageJSON={languageJSON}
            handleChange={this.handleChange}
            selectedVerificationOption={selectedVerificationOption}
            goNext={this.goNext}
            requestDetails={requestState.requestParams || {}}
            handleConfirmation={this.handleConfirmation}
         />
      );
   }
}

const mapStateToProps = ({ language: { language, languageJSON }, shared: { requestState, dialogAction } }) => ({
   language,
   languageJSON,
   requestState,
   dialogAction,
});

const mapDisptachToProps = {
   updateRequestState,
   getRequestState,
   executeDialogAction,
};

export default connect(mapStateToProps, mapDisptachToProps)(AddressVerification);